<template>
<div id="home">
    <mdb-navbar color="aqua-gradient" dark class="pt-0 pb-0 text-center" position="top" animated animation="3">
        <mdb-navbar-brand class="mt-1 mb-n2" href="https://mdbootstrap.com/">
            <img id="logo" src="../assets/logo_light.png" alt="">
        </mdb-navbar-brand>

        <mdb-navbar-toggler class="text-danger">
            <mdb-navbar-nav class="ml-2">
                <mdb-nav-item @click.native.prevent="info" active>INFO</mdb-nav-item>
                <mdb-nav-item @click.native.prevent="amenidades">AMENIDADES</mdb-nav-item>
                <mdb-nav-item @click.native.prevent="enlases">ENLASES</mdb-nav-item>
                <mdb-nav-item @click.native.prevent="galeria">GALERIA</mdb-nav-item>
                <mdb-nav-item @click.native.prevent="contacto">CONTACTO</mdb-nav-item>
            </mdb-navbar-nav>

            <div class="socialIcons">
                <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                    <span slot="tip">Telefono</span>
                    <a class=" mr-3 " role="button" href="tel:7876357455" slot="reference">
                        <mdb-icon fas icon="phone" size="lg" color="white" /></a>
                </mdb-tooltip>

                <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                    <span slot="tip">Facebook</span>
                    <a class="fb-ic mr-3" role="button" href="https://www.facebook.com/ParadiseAptPR/" target="_blank" slot="reference">
                        <mdb-icon fab icon="facebook-f" size="lg" color="white" /></a>
                </mdb-tooltip>
            </div>
        </mdb-navbar-toggler>
        
    </mdb-navbar>
</div>
</template>

<script>
import {
    mdbNavbar,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    mdbNavbarBrand,
    mdbIcon,
    mdbTooltip,
    mdbSmooth,
    mdbScrollSpy,

} from 'mdbvue';
export default {
    name: 'Main_Menu',
    methods: {
        isMobile() {
            if (screen.width <= 760) {
                
                return true;
            } else {
            
                return false;
            }
        },
        home() {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        },
        info() {
            if(this.isMobile()){
                window.scroll({
                top: 1300,
                left: 0,
                behavior: 'smooth'
            });
            }
            else{
            window.scroll({
                top: 930,
                left: 0,
                behavior: 'smooth'
            });
            }

        },
        amenidades() {
            if(this.isMobile()){
                window.scroll({
                top: 2350,
                left: 0,
                behavior: 'smooth'
            });
            }
            else{
            window.scroll({
                top: 1330,
                left: 0,
                behavior: 'smooth'
            });
            }
        },

        enlases() {
            if(this.isMobile()){
                window.scroll({
                top: 3350,
                left: 0,
                behavior: 'smooth'
            });
            }
            else{
            window.scroll({
                top: 2100,
                left: 0,
                behavior: 'smooth'
            });
            }
        },
        galeria() {
            if(this.isMobile()){
                window.scroll({
                top: 5250,
                left: 0,
                behavior: 'smooth'
            });
            }
            else{
            window.scroll({
                top: 2950,
                left: 0,
                behavior: 'smooth'
            });
            }
        },
        contacto() {
           if(this.isMobile()){
                window.scroll({
                top: 6500,
                left: 0,
                behavior: 'smooth'
            });
            }
            else{
            window.scroll({
                top: 3420,
                left: 0,
                behavior: 'smooth'
            });
            }
        },
    },
    components: {
        mdbNavbar,

        mdbNavbarToggler,
        mdbNavbarNav,
        mdbNavItem,
        mdbNavbarBrand,
        mdbTooltip,
        mdbIcon,
    },
    directives: {
        mdbScrollSpy,
        mdbSmooth
    }

}
</script>

<style lang="css">
.navbar-brand {
    padding-top: 0px;
    padding-bottom: 0px;
}

.top-nav-collapse {
    background-color: white !important;
    color: black !important;
}

.top-nav-collapse a {
    color: grey !important;
}

/* .navbar-nav{
  margin-bottom: 10px;;
} */

h1,
h5 {
    text-transform: uppercase;
}

h5 {
    letter-spacing: 3px;
}

#logo {
    height: 60px;
}

@media (max-width: 991px) {
    .socialMobile {
        text-align: center !important;
        margin-top: 20px;
        ;
    }

    .socialIcons {
        margin-top: 20px !important;
        margin-bottom: 20px !important;
    }

    .streak.streak-lg {
        max-height: 375px !important;
    }

    .icon_md {
        margin-top: 48px !important;
    }
}
</style>
